import { t } from '@configuratorware/configurator-frontendgui/Framework/i18n';
import { makeStyles } from '@material-ui/core/styles';
import React, { useEffect, useState } from 'react';
import { useMsal } from '@azure/msal-react';
import { loginRequest } from '../authConfig';

const useStyles = makeStyles(() => ({
  root: {
    width: '100%',
    height: '100%',
    display: 'flex',
    flex: 1,
    alignItems: 'center',
    paddingTop: 24,
    justifyContent: 'center',
    overflow: 'scroll',
  },
}));

const UnauthenticatedScreen = () => {
  const classes = useStyles();
  const [error, setError] = useState();
  const { instance } = useMsal();
  useEffect(() => {
    instance.loginRedirect({ ...loginRequest, redirectStartPage: window.location.href }).catch((error) => {
      console.log(error);
      setError(error);
    });
  }, []);

  return <div className={classes.root}>{error && t('login.error')}</div>;
};

export default UnauthenticatedScreen;
